import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-pending-value",
  templateUrl: "./pending-value.component.html",
  styleUrls: ["./pending-value.component.scss"],
  standalone: false,
})
export class PendingValueComponent implements OnInit {
  @Input() pending: boolean;

  constructor() {}

  ngOnInit(): void {}
}
